import { toRelayDateTime } from '../persistence/relay';

/**
 * Ob die App im Vordergrund ist — für Relays Geräteliste („aktiv“, „schläft“, „nicht
 * erreichbar“; Relay-Plan vom 2026-10-10, vom Nutzer freigegeben).
 *
 * - `ACTIVE`: im Vordergrund. **Auch hinter der Schlafscheibe** — sie dunkelt nur unsere
 *   Oberfläche ab, die App läuft (Entscheidung des Nutzers, 2026-10-10).
 * - `SLEEPING`: in den Hintergrund gegangen oder iPad gesperrt. `seit` ist die Gerätezeit des
 *   Wechsels (17 Ziffern, wie `creationDate`).
 */
export type AppModus = 'ACTIVE' | 'SLEEPING';

let modus: AppModus = 'ACTIVE';
let seit: string | null = null;

export function setzeAppModus(neu: AppModus, jetzt: Date = new Date()): void {
  modus = neu;
  seit = neu === 'SLEEPING' ? toRelayDateTime(jetzt) : null;
}

export function appModus(): { modus: AppModus; seit: string | null } {
  return { modus, seit };
}
